import { useToast } from '@/hooks/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';

/**
 * @deprecated Shadcn Toast ist deprecated.
 * Implementierung der neuen Komponente erfolgt durch Ticket: https://e2ngmbh.atlassian.net/browse/TG-21?atlOrigin=eyJpIjoiYzJjYmJkZWExNDVhNGQ1ZWE4NWQyNDdmOGU3NjQ5MmMiLCJwIjoiaiJ9
 */
export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
